var map = {
	"./popular-categories-1.png": "5280",
	"./popular-categories-2.png": "799f",
	"./popular-categories-3.png": "c217",
	"./popular-categories-4.png": "bd5c",
	"./popular-categories-5.png": "ec5d",
	"./popular-categories-6.png": "1457",
	"./popular-categories-7.png": "fc46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2e2";